import View from "layouts/tickets/View";
import ProtectedRoute from "routes/protectedRoutes.js";
import ManageTickets from "layouts/tickets/ManageTickets";
const TicketsRoutes = [


  {
    route: "tickets/viewvendorTicket/:id",
    key: "view-Vendor-tickets",
    component: <ProtectedRoute check="logout"><View props={{ 'type': "vendor" }} /></ProtectedRoute>
  },
  {
    route: "tickets/vendorTicket/:pageNo",
    key: "vendor-ticket",
    component: <ProtectedRoute check="logout"><ManageTickets props={{ 'type': "vendor" }} /></ProtectedRoute>
  },
  {
    route: "tickets/viewcustomerTicket/:id",
    key: "view-Customer-tickets",
    component: <ProtectedRoute check="logout"><View props={{ 'type': "customer" }} /></ProtectedRoute>
  },
  {
    route: "tickets/customerTicket/:pageNo",
    key: "Customer-ticket",
    component: <ProtectedRoute check="logout"><ManageTickets props={{ 'type': "customer" }} /></ProtectedRoute>
  }
  ];

export default TicketsRoutes;
